var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.333 2.667L2 4.667 4.333 7",
    stroke: "#7D8085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.667h7.665c2.294 0 4.242 1.873 4.332 4.166.094 2.424-1.908 4.5-4.332 4.5H3.999",
    stroke: "#7D8085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMzMzMzMgMi42NjY2M0wyIDQuNjY2NjNMNC4zMzMzMyA2Ljk5OTk2IiBzdHJva2U9IiM3RDgwODUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMiA0LjY2NjYzSDkuNjY0NjdDMTEuOTU5IDQuNjY2NjMgMTMuOTA3MyA2LjUzOTk2IDEzLjk5NjcgOC44MzMyOUMxNC4wOTEzIDExLjI1NjYgMTIuMDg5IDEzLjMzMzMgOS42NjQ2NyAxMy4zMzMzSDMuOTk5MzMiIHN0cm9rZT0iIzdEODA4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgRecover as ReactComponent };